import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { Organization } from '../../../types';

type MinOrg = Pick<Organization, 'id' | 'title' | 'access_level'>;

function searchOrganizations(query: string) {
  return get<MinOrg[]>('/api/organizations', false, {
    search: query || undefined,
  });
}

export const getSearchOrganizationsQueryKey = (query: string): QueryKey => ['organizations', 'search', query];

/**
 * Hook to search for organizations by title or ID.
 * @param query - The search query string
 * @param enabled - Whether the query should run (default: true)
 * @returns Query result containing the list of matching organizations
 */
export const useSearchOrganizations = (query: string, enabled: boolean = true) => {
  return useQuery<MinOrg[]>({
    queryKey: getSearchOrganizationsQueryKey(query),
    queryFn: () => searchOrganizations(query),
    enabled,
    staleTime: 30000, // Cache for 30 seconds
  });
};
